module.exports = __webpack_public_path__ + "img/branch.add3392e.png";